/*

*/


(function() {

  // Below are example event listeners.  They listen for theme events that 
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
 // Pavioti Jewellery - Open cart drawer automatically after Add to Cart
document.addEventListener('click', function(event) {
  const addToCartButton = event.target.closest('[data-add-to-cart], button[name="add"], .btn--add-to-cart');

  if (!addToCartButton) return;

  setTimeout(function() {
    const cartToggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');

    if (cartToggle) {
      cartToggle.click();
    }

    setTimeout(function() {
      const cartBottom = document.querySelector('[data-cart-bottom]');

      if (cartBottom) {
        cartBottom.classList.remove('cart--hidden', 'is-hidden', 'hidden');
        cartBottom.style.display = '';
        cartBottom.style.visibility = '';
        cartBottom.style.opacity = '';
      }
    }, 700);
  }, 2500);
}, true);
})();
